import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-data-access-error',
  templateUrl: './data-access-error.component.html',
  styleUrls: ['./data-access-error.component.scss'],
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class DataAccessErrorComponent implements OnInit {
  private router = inject(Router);

  ngOnInit(): void {}

  toHome() {
    this.router.navigate(['/home']);
  }
}
